import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCalendar = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M3 10C3 9.44772 3.44772 9 4 9H20C20.5523 9 21 9.44772 21 10V19C21 19.5523 20.5523 20 20 20H4C3.44772 20 3 19.5523 3 19V10ZM5 11V18H19V11H5Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M3 6C3 5.44772 3.44772 5 4 5H20C20.5523 5 21 5.44772 21 6V10C21 10.5523 20.5523 11 20 11H4C3.44772 11 3 10.5523 3 10V6ZM5 7V9H19V7H5Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M8 3C8.55228 3 9 3.44772 9 4V7C9 7.55228 8.55228 8 8 8C7.44772 8 7 7.55228 7 7V4C7 3.44772 7.44772 3 8 3Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M16 3C16.5523 3 17 3.44772 17 4V7C17 7.55228 16.5523 8 16 8C15.4477 8 15 7.55228 15 7V4C15 3.44772 15.4477 3 16 3Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15 15C15 14.4477 15.4477 14 16 14H17C17.5523 14 18 14.4477 18 15V16C18 16.5523 17.5523 17 17 17H16C15.4477 17 15 16.5523 15 16V15Z",
			fill: "currentColor"
		})
	]
});
export default SvgCalendar;
